"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../../../theme");
var useStyles = (0, _theme.makeStyles)({
  content: {
    display: 'flex'
  },
  footer: {
    display: 'flex',
    padding: '16px',
    justifyContent: 'flex-end'
  },
  leftIndent: {
    marginLeft: '16px'
  }
}, {
  name: 'DateRangePickerView'
});
exports.useStyles = useStyles;